import React, { useEffect, useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import '../Assets/Css/services.css';
import '../Assets/Css/home.css';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Button, ListGroup } from 'react-bootstrap';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { FaLeaf, FaFish, FaTint, FaSolarPanel, FaIndustry, FaCapsules, FaCity } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion, AnimatePresence } from 'framer-motion';


import service1 from '../Assets/Image/Agribannerimg1.png';
import service2 from '../Assets/Image/franchisismodel.png';
import service3 from '../Assets/Image/serviceconsulting.png'
import service4 from '../Assets/Image/RandDCenter.png';
import service5 from '../Assets/Image/Trainingandseminars.png'
import research1 from '../Assets/Image/RAndDLab.png';
import { FaAnglesRight } from "react-icons/fa6";

export default function Services() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);



  const [selectedIndex, setSelectedIndex] = useState(0);
  const contentRef = useRef(null);




  const service = [
    {
      title: "Seed & Fertilizer Supply",
      description: "Delivery of certified and high-quality seeds and fertilizers.",
      tag: "Quality Inputs",
      image: service1,
      points: [
        "Certified seeds for higher yield",
        "Government-approved fertilizers",
        "Timely seasonal delivery for farmers",
        "Consultation on crop-based inputs"
      ]
    },
    {
      title: "Franchise Model",
      description: "Providing agricultural franchise opportunities to aspiring entrepreneurs.",
      tag: "Business Opportunity",
      image: service2,
      slogan: "Your Business, Our Expertise",
      benefits: [
        "High returns with low investment",
        "Training and marketing support",
        "Continuous product supply"
      ]
    },
    {
      title: "Agri Consulting",
      description: "Expert guidance on crop selection, pest control, irrigation planning, and soil testing.",
      tag: "Expert Guidance",
      image: service3,
      points: [
        "Custom crop planning per region",
        "Organic and chemical pest solutions",
        "Soil testing and report analysis",
        "Irrigation method consultation"
      ]
    },
    {
      title: "R&D Center",
      description: "Focused on seed improvement and new agricultural technologies.",
      tag: "Innovation Hub",
      image: service4,
      slogan: "Discovering the Future of Farming Today",
      points: [
        "State-of-the-art research center for seed quality and disease resistance",
        "Focus on advanced production techniques",
        "Latest technological solutions offered to farmers"
      ]
    },
    {
      title: "Training & Seminars",
      description: "Workshops and educational programs for farmers and dealers.",
      tag: "Skill Development",
      image: service5,
      points: [
        "On-field training for modern farming",
        "Seminars with agri experts",
        "Certified skill-building programs",
        "Dealer training for crop advisory"
      ]
    }
  ];

  const testimonials = [
    {

      role: "Farmer – Maharashtra",
      message:
        "Hiranand Agri Solutions helped me switch to high-yield organic farming. Their team guided me through every step of the way.",
    },
    {

      role: "Agri Dealer – Uttar Pradesh",
      message:
        "From soil testing to product training, their support has helped me grow my agri-input business more confidently.",
    },
    {

      role: "Franchise Owner – Karnataka",
      message:
        "Becoming a Hiranand franchisee has been life-changing. Their branding, logistics, and advisory are world-class.",
    },
    {

      role: "Organic Vegetable Farmer – Madhya Pradesh",
      message:
        "Thanks to their quality seeds and timely training, my vegetable yield has doubled with better prices in local markets.",
    },
    {

      role: "Student, Agri Workshop – Rajasthan",
      message:
        "I attended their training seminar, and it was insightful. Now I feel ready to launch my own sustainable farm.",
    },
    {

      role: "Agri Consultant – Punjab",
      message:
        "The expert insights provided by Hiranand Agri Solutions helped our team implement smarter irrigation and crop planning strategies. Truly professional and impactful.",
    }
  ];


  return (
    <div style={{ minHeight: '100vh' }}>

<Helmet>
      <title>Our Services | Hiranand Agri Solutions Pvt. Ltd.</title>
      <meta
        name="description"
        content="Explore Hiranand Agri Solutions’ full range of services — certified seeds, fertilizers, agri-consulting, research & development, training seminars, and franchise opportunities for a sustainable farming future."
      />
      <meta
        name="keywords"
        content="agricultural services, seed supply, fertilizer delivery, agri consulting, agri franchise, R&D in farming, farmer training, crop planning, smart irrigation, organic farming"
      />
      <meta name="author" content="Hiranand Agri Solutions Pvt. Ltd." />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="Our Services | Hiranand Agri Solutions Pvt. Ltd." />
      <meta
        property="og:description"
        content="From certified seeds and fertilizers to expert agri-consulting, cutting-edge R&D, and franchise opportunities — Hiranand Agri Solutions supports farmers at every step."
      />
      <meta property="og:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" /> {/* Replace with your actual image */}
      <meta property="og:url" content="https://hiranandagrisolutions.com/services" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Our Services | Hiranand Agri Solutions Pvt. Ltd." />
      <meta
        name="twitter:description"
        content="Get reliable agri-inputs, expert consulting, innovative research, and franchise support from Hiranand Agri Solutions — your growth partner in farming."
      />
      <meta name="twitter:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://hiranandagrisolutions.com/services" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
      
      <div className=" bannerecommer-section d-flex align-items-center justify-content-center">
        <div className="bannerecommer-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Our Services</h2>
          <p className="banner1-subtitle" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="200">
            Innovative agri-solutions – from quality inputs to expert training and franchise support. Growing with farmers, together.
          </p>

        </div>
      </div>

      <section className="services-section py-5">
        <div className="mb-5" >
          <Row className="text-center section-heading mb-4" data-aos="fade-down" data-aos-delay="100">
            <Col>
              <h3 className="fw-bold section-title">
                Our
                <span style={{ color: '#16343E' }}> Services</span>
                <span className="title-decoration">  </span>
              </h3>
            </Col>
          </Row>
          <div className="row g-4 justify-content-center">
            {service.map((service, idx) => (
              <div className="col-12 col-md-4 col-lg-2_5" key={idx} data-aos="zoom-in" data-aos-delay="100">
                <div className="service-card h-100">
                  <img src={service.image} alt={service.title} className="img-fluid rounded-top service-img" />
                  <div className="p-3">
                    <span className="service-tag">{service.tag}</span>
                    <h5 className="mt-2 mb-2 fw-semibold">{service.title}</h5>
                    <p className="mb-0">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="">
          <Row>

            <Col md={4} className="mb-4">
              <div className="sidebar-card p-4  rounded">
                <h4 className="fw-bold mb-4 text-center" style={{ color: '#16343E' }}>Explore Services</h4>
                <ListGroup variant="flush">
                  {service.map((s, idx) => (
                    <ListGroup.Item
                      key={idx}
                      active={idx === selectedIndex}
                      // onClick={() => setSelectedIndex(idx)}
                      onClick={() => {
                        setSelectedIndex(idx);
                        setTimeout(() => {
                          if (window.innerWidth < 768 && contentRef.current) {
                            const top = contentRef.current.getBoundingClientRect().top + window.pageYOffset;
                            const offset = 130;

                            window.scrollTo({
                              top: top - offset,
                              behavior: 'smooth'
                            });
                          }
                        }, 100);
                      }}

                      action
                      className="fw-semibold sidebar-item"
                    >
                      {s.title}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
            </Col>


            <Col md={8} ref={contentRef}>
              <AnimatePresence mode="wait">
                <motion.div
                  key={selectedIndex}
                  initial={{ opacity: 0, x: 40 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -40 }}
                  transition={{ duration: 0.4 }}
                >
                  <div className="card shadow-lg border-0 h-100">
                    <img
                      src={service[selectedIndex].image}
                      alt={service[selectedIndex].title}
                      className="card-img-top"
                      style={{ height: '400px', objectFit: 'cover' }}
                    />
                    <div className="card-body ">
                      <h4 className="fw-bold text-center" style={{ color: '#16343E' }}>
                        {service[selectedIndex].title}
                      </h4>
                      <p className="mt-3 text-center">
                        <span className="badge bg-success">{service[selectedIndex].tag}</span>
                      </p>
                      <p className="mt-3">{service[selectedIndex].description}</p>
                      {service[selectedIndex].slogan && (

                        <h4 style={{ color: '#596B33' }}>
                          <strong>{service[selectedIndex].slogan}</strong>
                        </h4>
                      )}
                      <ul className="mt-3 " style={{ maxHeight: '300px', overflowY: 'auto' }}>


                        {service[selectedIndex].benefits && (
                          <>
                            <li className="mb-1"><strong>Benefits:</strong></li>
                            {service[selectedIndex].benefits.map((benefit, bidx) => (
                              <li key={`b-${bidx}`} className="ms-3">{benefit}</li>
                            ))}
                          </>
                        )}

                        {service[selectedIndex].points &&
                          service[selectedIndex].points.map((point, idx) => (
                            <li key={idx} className="mb-2">{point}</li>
                          ))
                        }
                      </ul>

                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </Col>

          </Row>
        </div>


      </section>

      <section className="py-5 rnd-focus-section" style={{ backgroundColor: '#f4f9f2' }}>


        <Container>
          <Row className="text-center mb-4" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                Research & Development <span style={{ color: '#16343E' }}> That Grows the Future</span>
                <span className="title-decoration mb-2"></span>
              </h3>
              <p className="text-muted">
                We bridge the gap between modern science and traditional knowledge to innovate for sustainable agriculture.
              </p>
            </Col>
          </Row>

          <Row>
            {/* Left: Core Research Areas */}
            <Col md={4} className="mb-4" data-aos="zoom-in">
              <div className="p-4 bg-white h-100 rounded shadow-sm">
                <h5 className="fw-bold mb-3  text-md-center text-start text-success">Core Research Areas</h5>
                <ul className="list-unstyled  " style={{ lineHeight: '2.3' }}>
                  <li>• Seed Quality Enhancement</li>
                  <li>• Organic Formulation Development</li>
                  <li>• Crop Disease Resistance</li>
                  <li>• Smart Irrigation Systems</li>
                  <li>• Biodegradable Packaging</li>
                </ul>
              </div>
            </Col>

            {/* Middle: Image + Slogan/Info */}
            <Col md={4} className="mb-4 d-flex flex-column gap-3" data-aos="zoom-in">
              <img
                src={research1}
                alt="R&D Lab"
                className="img-fluid rounded shadow-sm"
                style={{ height: '220px', objectFit: 'cover' }}
              />
              <div className="p-3 bg-white rounded shadow-sm">
                <h5 className="fw-bold text-success text-center mb-2">
                “Discovering the Future of Farming Today”
                </h5>
                <p className="text-muted mb-0 text-center" style={{ fontSize: '0.95rem' }}>
                  We are establishing a state-of-the-art research center focusing on seed quality, production techniques, and disease resistance. This center will offer the latest technological solutions to farmers.
                </p>
              </div>
            </Col>

            {/* Right: Our Vision */}
            <Col md={4} className="mb-4" data-aos="zoom-in">
              <div className="p-4 bg-white h-100 rounded shadow-sm">
                <h5 className="fw-bold mb-3 text-md-center text-start text-success">Our Vision</h5>
                <ul className="list-unstyled " style={{ lineHeight: '2.3' }}>
                  <li>• Technology for Every Farm</li>
                  <li>• Eco-Friendly Growth</li>
                  <li>• Farmer-Centric Innovation</li>
                  <li>• Data-Driven Cultivation</li>
                  <li>• Global Research Collaboration</li>
                </ul>
              </div>
            </Col>
          </Row>

          <div className="text-center mt-4">
            <Button variant="success" size="md" className="rounded-pill">
              Explore R&D <FaAnglesRight />
            </Button>
          </div>
        </Container>


      </section>

      <section className='py-5' style={{backgroundColor:'#f7f1e4'}}>
        <Container className='p-4'>
          <Row className="text-center mb-4" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                Franchise Opportunities <span style={{ color: '#16343E' }}> for Agricultural Growth </span>
                <span className="title-decoration mb-2"></span>
              </h3>
              <p className="text-muted">
                Partner with us to build a sustainable and profitable agri-business. Together, we grow stronger.
              </p>
            </Col>
          </Row>

          <Row>
            {/* Left: Image */}
            <Col md={6} className="mb-2" data-aos="zoom-in">
              <img
                src={service2} // use your actual image import or path here
                alt="Franchise Model"
                className="img-fluid rounded shadow-sm"
                style={{ height: '320px', objectFit: 'cover', width: '100%' }}
              />
            </Col>

            {/* Right: Details */}
            <Col md={6} className=" d-flex flex-column justify-content-between" data-aos="zoom-in">
              <div className="bg-white p-4 rounded shadow-sm h-100 d-flex flex-column justify-content-between">
                <div>
                  <h5 className="fw-bold text-success mb-4 text-center">
                    "Your Business, Our Expertise"
                  </h5>
                  <h6 className="fw-bold mb-2 text-success ">Key Benefits</h6>
                  <ul className="list-unstyled text-muted" style={{ lineHeight: '2.2' }}>
                    <li>• High returns with low investment</li>
                    <li>• Training and marketing support</li>
                    <li>• Continuous product supply</li>
                  </ul>
                </div>
                <div className="text-center mt-4">
                  <Button variant="success" size="md" className="rounded-pill">
                    Apply for a Franchise <FaAnglesRight />
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

      </section>


      <section className="testimonial-carousel-section my-5">
        <div className="container py-3 ">
          <Row className="align-items-center justify-content-center flex-md-row m-0">
            <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
              Voices of <span style={{ color: '#16343E' }}>Trust & Transformation</span>
              <span className="title-decoration mb-2"></span>
            </h3>
            <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
              Hear how Hiranand Agri Solutions is empowering farmers and entrepreneurs across India.
            </p>
            <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 4000 }}
                pagination={{ clickable: true }}
                loop
                spaceBetween={30}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 1 },
                  992: { slidesPerView: 1 },
                }}
              >
                {testimonials.map((testimonial, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="testimonial-agri-card">
                      {/* <div className="quote-agri-icon">❝</div> */}
                      <p className="testimonial-agri-text">{testimonial.message}</p>
                      <div className="agri-client-info">
                        <img
                          src={require('../Assets/Image/farmer1.jpg')}
                          alt={testimonial.name}
                          className="agri-avatar"
                        />
                        <div>
                          <div className="agri-name">{testimonial.name}</div>
                          <small className="text-muted">{testimonial.role}</small>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>





            </Col>
          </Row>
        </div>
      </section>

    </div>
  )
}
